import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSelector } from './PricingSelector';
export function PricingSection() {
  return <section className="py-12 md:py-16 px-4 bg-gray-50" id="pricing" data-id="element-248">
      <div className="max-w-2xl mx-auto" data-id="element-249">
        <div className="text-center mb-6" data-id="element-250">
          <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-gray-900 mb-2" data-id="element-251">
            Elegí tu Atlas
          </h2>
          <p className="text-sm md:text-base text-gray-600 font-medium" data-id="element-252">
            Ambas opciones incluyen los 6 bonos clínicos
          </p>
        </div>

        <CountdownTimer data-id="element-253" />

        <div className="mt-6 bg-white rounded-2xl p-4 md:p-6 shadow-xl border border-gray-100" data-id="element-254">
          <PricingSelector data-id="element-255" />
        </div>
      </div>
    </section>;
}